var FileUploadComponent = new JS.Class(EditorComponent, {
  initialize: function(titleSelector, fileSelector, isEmbeddedPage) {
    this.titleSelector = titleSelector;

    this.isEmbeddedPage = isEmbeddedPage;

    this.fileSelector = $(fileSelector);
    this.fileSelector.after(
      '<iframe id="tmp_upload_target" name="tmp_upload_target" style="display: none;"></iframe>'
    );

    var editorFormAction = $('#editor-form').attr('action');
    if (editorFormAction.indexOf('?') === 0) {
      editorFormAction = document.location.search;
    }
    if (editorFormAction.indexOf('&method=savePrelim') === -1) {
      editorFormAction += '&method=savePrelim';
    }
    this.fileSelector
      .closest('form')
      .attr('enctype', 'multipart/form-data')
      .attr('method', 'POST')
      .attr('action', editorFormAction)
      .attr('target', 'tmp_upload_target');

    this.fileUploaded = false;
  },

  getSaveData: function() {
    if (!this.fileUploaded) {
      if (!this.isEmbeddedPage) {
        $('.editor-save-watcher').html('Uploading...');
      }
      var that = this;
      $(window).on('message.fileupload', function(e) {
        e = e.originalEvent;
        if (
          e.origin === olOrigin ||
          Utilities.sameOrigin(e.origin, location.href)
        ) {
          if (e.data === 'prelim save successful') {
            that.handleSubmitComplete();
          }
          $(window).off('message.fileupload');
        }
      });
      this.fileSelector
        .closest('form')
        .unbind('submit')
        .removeAttr('onsubmit')
        .submit();
      return false;
    } else {
      return {
        FileUpload: {
          title: $(this.titleSelector).val(),
        },
      };
    }
  },

  handleSubmitComplete: function() {
    this.fileUploaded = true;
    this.editor.savePage();
  },
});
